module.exports = __webpack_public_path__ + "img/logo.b2d8a205.png";